interface FaqType {
	id: number;
	question: string;
	answer: string;
}

export const FAQs: FaqType[] = [
	{
		id: 0,
		question: "What services does BazaarRoom offer?",
		answer:
			"We are offering advertisement of your business and services and you can also sell your skills online(with annual subscription).",
	},
	{
		id: 1,
		question: "What do I have to do to advertise my business?",
		answer:
			"Sign up for the Promoter package and start uploading your (3 min each) videos about your business and products.You can explain on video how your products works etc",
	},
	{
		id: 2,
		question:
			"If I become a member of page'Sell your Skill' ,can i post my business in advertise business/products page?",
		answer:
			"Yes if you become a member you can upload an unlimited numbers of promo videos(3 min each) of your business or services",
	},
	{
		id: 3,
		question: "How do I become seller of my skill?",
		answer:
			"You need to become a member, submit your form with credentials,upload your videos of self introduction, pay annual fee depending on whether you choose Skills Teacher or Skills Teacher Plus, wait for approval and start selling your skill.",
	},
	{
		id: 4,
		question: "What do I get for my fees?",
		answer:
			"For this cost you will get:\n1. Advertisement of your skills on our website and our social media.\n2.Every week we will post articles about our new members with back link to your page, and most important ....we will assist you to sell your skills by offering our platform.",
	},
	{
		id: 5,
		question: "Is it safe to make payments on your website?",
		answer:
			"All payments will be done through very credible services (like Paypal etc), Our website will not accept credit card payments.",
	},
	{
		id: 6,
		question:
			"If I am seller, how i will get paid? And do I have to pay anything to BazaarRoom ?",
		answer:
			"You will get paid directly from by the buyer and there is no charge deducted by BazaarRoom. But you will pay a small amount of US$1.99 per hr for the use of streaming and subtitle services for each session with a client.",
	},
	{
		id: 7,
		question:
			"What happens If I do not pay fees for stream and subtitles services?",
		answer:
			"We will discontinue your access to the streaming service until payment is made",
	},
	{
		id: 8,
		question: "Can I buy steaming time in bulk for reduce fees(50 -100hr) ?",
		answer: "Yes but in the future.",
	},
	{
		id: 9,
		question: "Do I get a refund from the seller if I am not happy?",
		answer:
			"Sorry, no. You pay directly to the seller, but you can ask the payment provider to made a refund from the seller's account.",
	},
	{
		id: 10,
		question: "If I am not 100% satisfied with my experience what can I do?",
		answer: "You can write a review on the profile's and rate the service.",
	},
	{
		id: 11,
		question:
			"What do the  red, yellow and green lights mean the seller's profile?",
		answer: "Online status: Red = offline, Yellow = away, Green = online",
	},
	{
		id: 12,
		question:
			"How long does it take for approval of my videos or profile before they go online?",
		answer:
			"It will take up to 8 hr (for advertisers) and up to 12 hr for sellers after they make payment",
	},
	{
		id: 13,
		question: "What browsers support you App and web?",
		answer: "Most of them",
	},
	{
		id: 14,
		question: "How old do I have to be to join your website?",
		answer: "18 years old",
	},
	{
		id: 15,
		question:
			"If i have a child and he/she wants to take music classes etc online using your website do I need to be present?",
		answer: "Yes",
	},
	// {
	//   question: "How you will know if a child is alone online?",
	//   answer: "",
	// },
	{
		id: 16,
		question: "What are the rules of your website",
		answer:
			"Please see at our policy page. It is very important to respect the community Rules.",
	},
];